import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';

function RelayCountry(props) {
  const icon = getUnicodeFlagIcon(props.country);
  const tooltip = props.name;
  if (props.text) {
    return (
      <>
        {icon} {" "}
        {tooltip}
      </>
    )
  } else {
    return (
      <OverlayTrigger
        overlay={
          <Tooltip>
            {tooltip}
          </Tooltip>
        }
      >
        <span>
          {icon}
          {props.text ? tooltip + " " : ""}
        </span>
      </OverlayTrigger>
    );
  }
}

export default RelayCountry;
